import {OverlayTrigger, Tooltip} from "react-bootstrap";
import React from "react";
 const LineCrudTableRowModal2 = ({el, i, desvinculedClient}) => {
    let {code, name, lastName, numDocument/* ,mail,hasActiveReserve,hasMora,maximumFinancingAmount, _id */} = el;

    const handleChangeSelect = () => {
        desvinculedClient(el);
        }
    return (
        <tr key={code}>
            <th scope="row">{i + 1}</th>
            <td className="text-center">{name}</td>
            <td className="text-center">{lastName}</td>
            <td className="text-center">{numDocument}</td>
            <td className="text-center">
                <OverlayTrigger placement="top"
                                overlay={<Tooltip id="tooltip-top">Desvincular Cliente</Tooltip>}>
                    <button type="button" 
                            className="btn btn-sm btn-danger"
                            onClick={handleChangeSelect}>
                        <i className="bi bi-trash"/>
                    </button>
                </OverlayTrigger>
            </td>
        </tr>
    );
}
export default LineCrudTableRowModal2;
